import React from 'react'
import { Box } from '@mui/material'
import FillCreditLeave from '../components/fillCreditLeave'
import AdxButton from 'components/custom/AdxButton'

const FillCreditLeaveView = ({ formikProps, reasonRequired }) => {
  const {
    values,
    handleChange,
    setFieldValue,
    validateField,
    handleSubmit,
    isSubmitting,
    setFieldTouched,
    errors,
    touched,
  } = formikProps

  return (
    <Box
      sx={{
        minHeight: 'calc(70vh - 112px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      {/* Fill Credit Leave Form*/}
      <FillCreditLeave
        values={values}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        reasonRequired={reasonRequired}
        setFieldTouched={setFieldTouched}
        errors={errors}
        touched={touched}
        validateField={validateField}
      />
      {/* Button part */}
      <Box
        sx={{
          position: 'sticky',
          bottom: '0',
          width: '100%',
          display: 'flex',
          justifyContent: { xs: 'center', md: 'end' },
          alignItems: 'center',
          bgcolor: 'primary.light',
          px: 3,
          py: 2,
          gap: 1,
          borderTop: '1px solid',
          borderColor: 'grayscale.line-light',
        }}
      >
        <AdxButton
          variant={'contained'}
          onClick={handleSubmit}
          sx={{ width: 2 / 3 }}
          disabled={isSubmitting}
        >
          Request
        </AdxButton>
      </Box>
    </Box>
  )
}

export default FillCreditLeaveView
